import React, { useEffect, useMemo, useState } from 'react';
import Icon from '@/components/Icon';
import styles from './item.module.less';
import { useTranslation } from 'react-i18next';

export interface IChild {
  id: number;
  text: string;
}
interface ISubItemProps {
  hasMore: boolean;
  initialPageNum?: number;
  data: IChild[];
  loadMore: () => void;
  onPress?: (id: number) => void;
}

const SubItem: React.FC<ISubItemProps> = ({
  data,
  hasMore,
  loadMore,
  onPress,
}) => {
  const { t } = useTranslation();

  const load = async () => {
    await loadMore?.();
  };

  return (
    <div className={styles.childs}>
      {data?.map((child) => {
        return (
          <div
            key={child.id}
            onClick={() => onPress?.(child.id)}
            className={`${styles.child} ${styles.text}`}
            dangerouslySetInnerHTML={{ __html: child.text }}
          ></div>
        );
      })}
      {hasMore && (
        <div className={styles.loadMore} onClick={load}>
          <p>{t('see_more')}</p>
          <Icon iconName={'arrow_down'} imgClass={styles.arrow} />
        </div>
      )}
    </div>
  );
};

interface IProps {
  id?: string;
  text?: string;
  iconName?: string;
  right?: React.ReactNode;
  hideLine?: boolean;
  onPress?: (id: string) => void;
  iconStyle?: any;
  textStyle?: any;
  expandConfig?: {
    expandable?: boolean;
    isExpand: boolean;
    childs?: IChild[];
    hasMore: boolean;
    initialPageNum?: number;
    loadMore: () => void;
    onPressChild?: (id: number) => void;
  };
}
const PanelItem: React.FC<IProps> = ({
  id,
  text,
  iconName,
  right,
  hideLine,
  onPress,
  iconStyle = styles.icon,
  textStyle,
  expandConfig,
}) => {
  const arrow = useMemo(
    () => (expandConfig?.isExpand ? 'arrow_up' : 'arrow_down'),
    [expandConfig],
  );

  return (
    <>
      <div onClick={() => onPress?.(id)} className={styles.container}>
        <div className={`${styles.contentBox} ${hideLine && styles.hideLine}`}>
          {Boolean(iconName) && (
            <div className={styles.iconBox}>
              <Icon iconName={iconName} imgClass={iconStyle} />
            </div>
          )}
          <div className={styles.content}>
            <span
              className={`${styles.text} ${textStyle}`}
              dangerouslySetInnerHTML={{ __html: text }}
            ></span>
            {right && !expandConfig?.expandable && (
              <div className={styles.rightBox}>{right}</div>
            )}
            {expandConfig?.expandable && (
              <Icon
                iconName={arrow}
                imgClass={`${styles.rightBox} ${styles.arrow}`}
              />
            )}
          </div>
        </div>
      </div>
      {expandConfig?.isExpand && (
        <SubItem
          data={expandConfig.childs}
          hasMore={expandConfig.hasMore}
          loadMore={expandConfig.loadMore}
          initialPageNum={expandConfig.initialPageNum}
          onPress={expandConfig.onPressChild}
        />
      )}
    </>
  );
};

export default PanelItem;
